import { useState,useRef,useEffect } from "react";
import {Label} from '../../components/fieldsComp';
import {settingservices} from '../../services/settingServices';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';

const Subsconfig = () =>{

    const toast = useRef(null); 
    const [initialvalue,setvalues] = useState({
        'isactive':'active'
    });

    const [subscriptionsperm,setSubscription] = useState([]);
    
    useEffect(()=>{
      getsubscription();
    },[])
    
    const handleChanges = (e) =>{
         setvalues((prevData)=>{
             return {
                 ...prevData,
                 [e.target.name]:e.target.value
             } 
         });   
    }

    const addsubscriptionperm = (e) =>{
        e.preventDefault();
        // console.log("add subscriiption"); 
        // console.log(initialvalue);
        settingservices.addsubscriptionperm(initialvalue).then((response)=>{
             if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Subscription', detail: 'Added successfully' });
                getsubscriptionperm();
             }else{
                toast.current.show({ severity: 'error', summary: 'Subscription', detail: 'Not added' }); 
             }
        }).catch((error)=>{
             console.log(error);
        })
    }


    const getsubscriptionperm = () =>{
        settingservices.getsubscriptionpperm().then((response)=>{
             if(response.status == 200){
                setSubscription(response.data.data);
             }else{
                setSubscription([]);
             }
        }).catch((error)=>{
             setSubscription([]);
             console.log(error);
        })
    }

    const getsubscription = () =>{
      settingservices.getsubscription().then((response)=>{
           console.log("resonse data");
           console.log(response);
           if(response.status == 200){
              // console.log(response);
              setSubscription(response.data.data);
           }else{
              setSubscription([]);
           }
      }).catch((error)=>{
           setSubscription([]);
          //  console.log(error);
      })
  }


    const displaysubscriptions = () =>{
         let tempdata = [];
         subscriptionsperm.forEach((value)=>{
          tempdata.push(<option value={value.id}>{value.name}</option>);
            // console.log(value);
         })

         return tempdata;

    }
   return (
    <>
       <Toast ref={toast} /> 
           <div className="card">
            <div className="card-body">
           <form onSubmit={(e)=>addsubscriptionperm(e)}>
            <div class="row">
                 <div className="col-md-2"> 
                    <div class="form-group">
                        <Label name={'Select Subscription'}/> 
                        <select name="subscription" onChange={handleChanges} required className="form-control">
                            {displaysubscriptions()}
                        </select>
                    </div>
                </div>
                
                <div className="col-md-2"> 
                    <div class="form-group">
                        <Label name={'Users Count'}/> 
                        {/* <label for="email2">Isactive</label>       */}
                        <input type="number" onChange={handleChanges} required className="form-control"/>                        
                       
                    </div>
                </div>

                <div className="col-md-2"> 
                    <div class="form-group">
                        <Label name={'No of days'}/> 
                        {/* <label for="email2">Isactive</label>       */}
                        <input type="number" onChange={handleChanges} required className="form-control"/>                        
                       
                    </div>
                </div>

                <div className="col-md-3">
                   <div class="form-group">
                       <br/>
                      <button className="btn btn-success-custom" type="submit">Save</button>
                   </div>
                  
                </div>
                
             </div>
             </form>
             </div>

             <div className="row">
                 <div className="col-md-12">
                 <div class="card">
                  <div class="card-header">
                    <h4 class="h5">Permissions</h4>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table
                        id="multi-filter-select"
                        class="display table table-striped table-hover"
                      >
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Isactive</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                            
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> 
                
                </div>   
             </div>
             </div>  
    
    </>
   );       
}

export default Subsconfig;